import { h } from "preact";

import i18n from "../../i18n";
import { getText } from "../../helpers.js";
import embassyApi from "../../api/embassy.js";

import Button from "../Button.jsx";
import DisplayLocation from "../DisplayLocation.jsx";
import HeaderIcon from "../HeaderIcon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import { useEffect, useState } from "preact/hooks";

export default {
  diplomatic_mission: ({ productId, onNext, onRestart }) => {
    const [embassy, setEmbassy] = useState(null);
    const [countEmbassies, setCountEmbassies] = useState(0);

    useEffect(async () => {
      const data = await embassyApi.fetch(productId);
      setEmbassy(data.embassy);
      setCountEmbassies(data.countEmbassiesInCountry);
    }, []);

    if (!embassy) return <section class="task-page">Loading …</section>;

    return (
      <section class="task-page">
        <HeaderIcon>diplomatic_mission_finder</HeaderIcon>
        <h1 class="task-page__headline">{embassy.name}</h1>

        <div class="task-page__content">
          <List class="mb-48">
            {embassy.street && (
              <ListItem iconFront="location_on">{embassy.street}</ListItem>
            )}
            {embassy["tel."] && (
              <ListItem iconFront="phone">{embassy["tel."]}</ListItem>
            )}
            {embassy.eMail && (
              <ListItem iconFront="mail">{embassy.eMail}</ListItem>
            )}
            {embassy.fax && (
              <ListItem iconFront="print">{embassy.fax}</ListItem>
            )}
            {embassy.website && (
              <ListItem iconFront="language">{embassy.website}</ListItem>
            )}
          </List>
          <List class="mb-32">
            {embassy["postal address"] && (
              <ListItem overline="Postal Address">
                {embassy["postal address"]}
              </ListItem>
            )}
            {embassy["opening hours"] && (
              <ListItem overline="Office hours">
                {embassy["opening hours"]}
              </ListItem>
            )}
          </List>

          <DisplayLocation
            title={i18n.t("tasks.diplomatic_mission.mapTitle")}
            location={embassy}
            class="mb-32"
          />
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.done")}</Button>
          {countEmbassies > 1 && (
            <Button text onClick={onRestart}>
              {i18n.t("actions.discard_result")}
            </Button>
          )}
        </div>
      </section>
    );
  },

  diplomatic_mission_unknown: ({ answers, onNext, onRestart }) => {
    return (
      <section class="task-page">
        <HeaderIcon>diplomatic_mission_finder</HeaderIcon>
        <h1 class="task-page__headline">Embassy unknown</h1>

        <p class="task-page__content">
          We do not have any knowledge about an embassy in{" "}
          {getText(answers.countryOfResidence)}. If you find one, please{" "}
          <a href="mailto://info@nioomi.com">let us know</a> about it.
        </p>

        <div class="task-page__buttons">
          <Button secondary onClick={onNext}>
            {i18n.t("actions.ok")}
          </Button>
        </div>
      </section>
    );
  },
};
